import $ from 'jquery';

require.ensure([], () => {

    require(['pickadate/lib/picker.date'], () => {
        var lang = {},
            checkout,
            checkoutUtility;

        // EN is default, only override for german
        if ($('.language-switcher select option:selected').text().trim().toUpperCase() == 'DE') {
            lang = {
                monthsFull: [
                    'Januar',
                    'Februar',
                    'März',
                    'April',
                    'Mai',
                    'Juni',
                    'Juli',
                    'August',
                    'September',
                    'Oktober',
                    'November',
                    'Dezember'
                ],
                monthsShort: [
                    'Jan',
                    'Feb',
                    'Mär',
                    'Apr',
                    'Mai',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Okt',
                    'Nov',
                    'Dez'
                ],
                weekdaysFull: [
                    'Sonntag',
                    'Montag',
                    'Dienstag',
                    'Mittwoch',
                    'Donnerstag',
                    'Freitag',
                    'Samstag'
                ],
                weekdaysShort: [
                    'So',
                    'Mo',
                    'Di',
                    'Mi',
                    'Do',
                    'Fr',
                    'Sa'
                ],

                today: 'Heute',
                clear: 'Löschen',
                close: 'Schließen'
            };
        }

        checkout = $('.check_out_date').pickadate($.extend(lang, {
            firstDay: 1,
            min: new Date(),
            format: 'dd.mm.yyyy',
            formatSubmit: 'dd.mm.yyyy'
        }));

        checkoutUtility = $('.check_out_date__utility').pickadate($.extend(lang, {
            firstDay: 1,
            min: new Date(),
            format: 'dd.mm.yyyy',
            formatSubmit: 'dd.mm.yyyy'
        }));

        $('.check_in_date').pickadate($.extend(lang, {
            firstDay: 1,
            min: new Date(),
            format: 'dd.mm.yyyy',
            formatSubmit: 'dd.mm.yyyy',

            onSet: function(thingSet) {
                checkout.pickadate('picker').set('min', new Date(thingSet.select));
            }
        }));

        $('.check_in_date__utility').pickadate($.extend(lang, {
            firstDay: 1,
            min: new Date(),
            format: 'dd.mm.yyyy',
            formatSubmit: 'dd.mm.yyyy',

            onSet: function(thingSet) {
                checkoutUtility.pickadate('picker').set('min', new Date(thingSet.select));
            }
        }));
    });

}, 'datepicker');



// WEBPACK FOOTER //
// ./resources/assets/js/lib/datepicker.js